module.exports = __webpack_public_path__ + "static/media/pool-live-logo-header.71258762.png";